/**
 * Formats an ISO date string as "Lundi 27 juillet 2026" (weekday capitalized, `fr-FR` has no option for it).
 */
const formatNotificationDate = (isoDate: string): string => {
  const formatted = new Date(isoDate).toLocaleDateString('fr-FR', {
    weekday: 'long',
    day: '2-digit',
    month: 'long',
    year: 'numeric',
  });

  return formatted.charAt(0).toUpperCase() + formatted.slice(1);
};

export { formatNotificationDate };
